var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jin-nang-buy-or-sale',{attrs:{"isSell":_vm.isSell}})
}
var staticRenderFns = []

export { render, staticRenderFns }